import {
  ArrowPathIcon,
  PauseIcon,
  PlayIcon,
} from '@heroicons/react/24/outline';

import { CustomerDeleteOptionParams } from '@/sections/customerManagement/types';
import type { DropdownOption } from '@/types/dropdown.types';

/**
 * Builds management action dropdown options
 *
 * Provides options for customer type updates and pause/resume scanning with
 * keyboard shortcut hints. Deletion is intentionally NOT offered here: it is
 * single-tenant only (A11) and is initiated exclusively via the per-row
 * "Delete Customer" action (Praetorian-gated) in CustomerTable. A bulk
 * "Delete" entry would silently target only the first selected customer.
 *
 * @param params - Parameters for building management options
 * @returns Array of dropdown options for customer management actions
 */
export const getCustomerManageOptions = ({
  customers,
  handlers,
  onModalOpen,
}: CustomerDeleteOptionParams): DropdownOption[] => {
  const hasCustomers = customers.length > 0;

  return [
    {
      label: 'Update Type',
      icon: <ArrowPathIcon className="size-5" />,
      onClick: () => onModalOpen?.('updateType', customers),
      disabled: !hasCustomers,
      count: ` ⌥ T`,
    },
    {
      label: 'Pause Scanning',
      icon: <PauseIcon className="size-5" />,
      onClick: () => handlers.handlePauseScanning(customers),
      disabled: !hasCustomers,
      count: ` ⌥ P`,
    },
    {
      label: 'Resume Scanning',
      icon: <PlayIcon className="size-5" />,
      onClick: () => handlers.handleResumeScanning(customers),
      disabled: !hasCustomers,
      count: ` ⌥ R`,
    },
  ];
};
